module.exports = __webpack_public_path__ + "static/img/ncmcard.64067ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ncmcard.png
// module id = CVwW
// module chunks = 1